import type { DotProps } from "@/v2-backoffice-client/components/dot"

// Mirrors the sharingrisk.Level* codes (libs/backends/v2-sharing-risk) and the
// score bands: None 0–1, Low 2–4, Moderate 5–7, High 8–12, Critical 13+.
const SHARING_RISK_NONE = 1
const SHARING_RISK_LOW = 2
const SHARING_RISK_MODERATE = 3
const SHARING_RISK_HIGH = 4
const SHARING_RISK_CRITICAL = 5

const SHARING_RISK_STYLES: Record<number, DotProps["variant"]> = {
  [SHARING_RISK_NONE]: "secondary",
  [SHARING_RISK_LOW]: "info",
  [SHARING_RISK_MODERATE]: "warning",
  [SHARING_RISK_HIGH]: "orange",
  [SHARING_RISK_CRITICAL]: "destructive",
}

export function getSharingRiskVariant(level: number): DotProps["variant"] {
  return SHARING_RISK_STYLES[level] ?? "secondary"
}
